import { render } from "./invoice_template.vue?vue&type=template&id=1eda3626&scoped=true"
import script from "./invoice_template.vue?vue&type=script&lang=js"
export * from "./invoice_template.vue?vue&type=script&lang=js"

import "./invoice_template.vue?vue&type=style&index=0&id=1eda3626&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eda3626"]])

export default __exports__